module.exports = {
  global: {
    empty: 'Empty',
    dialogTitle: 'Tips',
    back: 'Back'
  },
  nopaid: {
    title: 'Tips',
    message: 'You have unpaid orders',
    cancleBtn: 'Cancel order',
    goDetail: 'Go to view',
    goPay: 'Go to pay'
  },
  home: {
    checkIn: 'CheckIn',
    checkOut: 'CheckOut',
    night: 'Nights',
    cityPickerTitle: 'Pick City',
    datePickerTitle: 'Pick Date',
    loadall: 'The above is all hotel information',
    searchTip: 'Search hotels',
    searchPlaceholder: 'Please enter the hotel name',
    listTile: 'Recommend',
    distance: 'Distance',
    price: 'Market Price',
    isEnd: 'Booking is closed',
    noStart: 'Booking has not started yet',
    timeOut: 'Booking has ended',
    cityUnknow: 'Unknow',
    area: 'Area：'
  },
  hotel: {
    navigate: 'Navigation',
    contact: 'Contact',
    distance: 'Distance',
    intro: 'Introduction',
    roomType: 'House Type',
    navigateTips: 'For a better navigation experience, please browse this page on wechat.',
    confirmText: 'Got It',
    roomTypeBtn: 'House Type',
    checkIn: 'CheckIn',
    checkOut: 'CheckOut',
    night: 'Nights',
    detail: 'Details',
    marketPrice: 'Market Price',
    bookBtnText: 'Book',
    loadall: 'All contents have been loaded',
    datePickerTitle: 'Pick Date',
    start: 'Lowest'
  },
  book: {
    checkIn: 'CheckIn',
    checkOut: 'CheckOut',
    total: '',
    night: 'Nights',
    bedNum: 'Number of beds',
    roomNum: 'Number of rooms',
    formTitle: 'Fill in information',
    saleTitle: 'Booking information',
    submitText: 'Confirm',
    form: {
      countrycode: 'Country code',
      label: 'Code',
      placeholder: 'Please enter verification code',
      empty: 'Please fill in the verification code',
      err: 'Incorrect verification code format',
      send: 'Send',
      format: 'ss s',
      emptyc: 'Please fill in the country code',
      emptyp: 'Please fill in cell phone number',
      success: 'Sending successfully, please pay attention to check the SMS',
      discern: 'Content recognition...'
    },
    validator: {
      phone: 'The phone number format is wrong',
      email: 'Please enter a valid email address',
      idnumber: 'Please enter a valid ID number',
      digit: 'Please enter a whole number or a decimal; when a decimal is used, a maximum of two digits are kept after the decimal point',
      letter: 'Please do not enter characters other than letters',
      require: 'This item is required'
    },
  },
  notify: {
    uploadImg: 'Only. JPG,. JPEG,. PNG images can be uploaded!',
    uploadSize5: 'The file size cannot exceed 5MB!',
    uploadSize15: 'The file size cannot exceed 15MB!',
    uploadSuc: 'File uploaded successfully!',
    payVoucher: 'Please upload the payment voucher',
    orderTip1: 'This order does not support payment within the applet',
    orderTip2: 'The order needs to initiate the payment process in the applet',
    browserTip: 'Please open this page on wechat',
    noFinish: 'You have unfinished projects',
    countryCodeTip: 'Please fill in the country code!',
    phoneTip: 'Please fill in your mobile phone number!',
    phoneErr: 'Wrong format of mobile phone number!',
    sendSms: 'Sent successfully, please check the SMS',
  },
  result: {
    wait: 'Waiting for payment',
    success: 'Reservation succeeded',
    invalid: 'Invalid',
    cancel: 'Cancelled',
    orderTitle: 'Order information',
    orderNo: 'Order No.',
    checkHotel: 'Hotel',
    checkRoom: 'Room type',
    orderGood: 'Goods',
    price: 'Price',
    orderNum: 'Number',
    checkInDate: 'Check in date',
    checkOutDate: 'Check out date',
    checkDays: 'Nights',
    amounts: 'Amounts',
    guestInfo: 'Subscriber information',
    payment: 'Immediate payment',
    continue: 'Continue Booking',
  },
  parment: {
    voucher: 'Click upload payment voucher',
    submit1: 'Order',
    cancel: 'Cancel',
    submit2: 'Confirm',
    wxpay: 'Wechat Pay',
    alipay: 'Alipay',
    paypal: 'PayPal',
    offline: 'Transfer payment'
  }
}